import * as ActionTypes from '../actions';

const initialState = {  
    currentCompany: {
        id: null,
        address: {
                id: null,
                companyId: null,
                name: null,
                firstName: null,
                lastName: null,
                bussinessId: null,
                taxId: null,
                vatNo: null,
                vatPayer: null,
                steet: null,
                houseNumber: null,
                city:  null,
                postalCode: null,
                countryIso: null,
                commercialRegister: null,
                slogan: null,
                phone: null,
                mobilePhone: null,
                privateEmail: null,
                officeEmail: null,
                description: null,
                filePhotoId: null,
                fileLogoId: null,
                fileStampId: null,
                privatePerson: null,
                credit: null,
                creditValue: null,
                paymentDue: null,
                discount: null
        } 
        
    }
};

const reducer = (state = initialState, action) => {
    switch (action.type) {       
        case ActionTypes.LOAD_COMPANY:
            return {
                ...state,
                currentCompany: action.currentCompany
            };
        case ActionTypes.SAVE_COMPANY:
                return {
                    ...state,
                    currentCompany: action.currentCompany
            };
        default:
            return {...state};
    }
};

export default reducer;
